import React from 'react';
import GUI from '../containers/gui.jsx';
import {getCloudHost} from '../lib/nexus-cloud-host.js';

const cloudHost = getCloudHost();

const RenderGUI = props => (
    <GUI
        cloudHost={cloudHost}
        canUseCloud
        hasCloudPermission
        canSave={false}
        basePath={process.env.ROOT}
        canEditTitle
        enableCommunity
        {...props}
    />
);

export default RenderGUI;
